import { createContext, useContext } from "react";

export type PageVariant = "it" | "rnd";

const PageVariantContext = createContext<PageVariant>("it");

export const PageVariantProvider = PageVariantContext.Provider;

export function usePageVariant(): PageVariant {
  return useContext(PageVariantContext);
}

/** rndPage에 정의된 섹션만 접두. contact는 일부 키만 오버라이드 */
const RND_PAGE_ROOTS = new Set([
  "hero",
  "services",
  "about",
  "development",
  "portfolio",
  "testimonials",
  "team",
]);

const RND_CONTACT_KEYS = new Set([
  "title",
  "description",
  "description2",
  "formTitle",
]);

function toRndPageKey(path: string): string | null {
  const root = path.split(".")[0];
  if (RND_PAGE_ROOTS.has(root)) {
    return `rndPage.${path}`;
  }
  if (root === "contact") {
    const sub = path.slice("contact.".length);
    if (RND_CONTACT_KEYS.has(sub)) {
      return `rndPage.${path}`;
    }
  }
  return null;
}

/** IT는 기존 키, R&D는 rndPage.* (정의된 범위만) */
export function useSectionT(): (path: string) => string {
  const variant = usePageVariant();
  return (path: string) => {
    if (variant !== "rnd") return path;
    return toRndPageKey(path) ?? path;
  };
}
